<template>
  <div>
    <List
      url="sre-api/devicecount/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="false"
      :useBatchSuffix="false"
    >
      <div slot="Filter">
        <el-row :gutter="20">
          <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
            <label>云平台：</label>
            <el-select multiple v-model="selectClouds" placeholder="请选择云平台（多选）" style="width:200px;margin-right:10px;" size="small">
              <el-option
                v-for="cloud in cloudEnvList"
                :label="cloud"
                :key="cloud"
                :value="cloud"
                @click.native="handleCloudSelectClick(cloud)"
              ></el-option>
            </el-select>

            <label>设备固件版本：</label>
            <el-input
              v-model="searchData.firmware"
              size="small"
              style="width:160px;margin-right:10px;"
              placeholder="请输入设备固件版本"
            ></el-input>

            <el-button @click="search" type="primary" size="small">Search</el-button>
          </el-col>
        </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>
    </List>
  </div>
</template>

<script>
import List from "../components/common/List.vue";

export default {
  components: {
    List
  },
  data() {
    return {
      dialogFormVisible: false,
      selectStatus: "全部",
      title: "设备数量",
      tanle: [
        { name: "cloud", label: "云平台" },
        { name: "community_count", label: "社区设备" },
        { name: "personal_count", label: "单住户设备" },
        { name: "all_count", label: "全部" }
      ],
      selectClouds: ["dev"],
      searchData: {
        cloud: "dev",
        firmware: "119"
      },
      operation: [],
      updateList: 0,
      updateForm: {},
      cloudEnvList: [],
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchSreApi();
  },
  methods: {
    dealList(data) {
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateType = "add";
      this.updateForm = { switch: "启用", device_type: "社区设备", days: 30 };
      this.updateBlock = true;
    },
    search() {
      if (Array.isArray(this.selectClouds)) {
        // 多选时是数组
        this.searchData.cloud = this.selectClouds.join(",");
      } else {
        // 如果是单选情况，直接赋值
        this.searchData.cloud = this.selectClouds;
      }
      this.updateList++;
    },
    handleCloudSelectClick(cloud){
      const isHasAllOption = this.selectClouds.some(item => item === 'all');
      const curSelectIsAllOption = cloud === 'all';
      if(isHasAllOption && curSelectIsAllOption){
        this.selectClouds = ['all'];
      }else if(isHasAllOption && !curSelectIsAllOption){
        this.selectClouds = [cloud];
      }
      this.searchData.cloud = isHasAllOption && curSelectIsAllOption?'':this.selectClouds.join(",");
    },
    deletedata(val) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "sre-api/devicecount/" + val.id + "/";
        this.$http["delete"](url,
          () => {
            this.$baseNotice.message("删除成功");
            this.updateList++;
          },
          () => {
            this.$message({message: "删除失败", type: "error"});
          }
        );
      }).catch(() => {
        this.$message({message: "已取消删除", type: "warning"});
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchSreApi() {
      this.$http["get"](
        "sre-api/url/", {}, (data) => {
          this.cloudEnvList = ["all", ...data.data.results.map(item => item.cloud)];
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
